<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-users-table />
    </div>
  </div>
</template>
<script>
/* 
  Class: Users
  Description: This class representing a main entry point for users.
*/

/* Imports */
import CardUsersTable from "@/components/Cards/Users/CardUsersTable.vue";
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: '%s | ' + this.$route.name
    };
  },
  
  /* 
    Define different components for reusability. 
  */
  components: {
    CardUsersTable,
  }
};
</script>
